/**
 * The inviter's fruit on Today (fruit-map gap 4: the invite seed was cut in half; Invite.tsx showed "{first} is on the team" only
 * on the tablet-PIN path). When someone this person invited finishes joining (by link, QR, code or email), Today says so with the
 * team's count: "Sam is set up. 2 of 3 on your team are set up." Set up = joined; never a check-in or anything about health (T4).
 * Shown for 3 days after the join, below what's due (never above a safety card), until "Got it".
 */
import { useState } from "react";
import { inviteeSetUpLine } from "@logwave/core";
import { useLoad } from "../lib/useLoad.ts";
import { useApi, useSession } from "../session.tsx";
import { Button } from "./ui.tsx";
import { RewardCheck } from "./Reward.tsx";

export const JUST_SET_UP_MS = 3 * 86_400_000;
const SEEN_KEY = "cleancleaver.setup-seen";

function seen(): string[] { try { return JSON.parse(localStorage.getItem(SEEN_KEY) ?? "[]") as string[]; } catch { return []; } }

export function JustSetUpCard() {
  const api = useApi();
  const s = useSession();
  const [gone, setGone] = useState<string[]>(seen);
  const d = useLoad(async () => {
    const [invites, team] = await Promise.all([api.invites(s.org.id), api.employees(s.org.id)]);
    return { invites, team };
  }, [api, s.org.id]);
  if (!d.data) return null;
  const now = Date.now();
  const mine = d.data.invites
    .filter((i) => i.acceptedAt && i.invitedBy === s.me.user.id && now - new Date(i.acceptedAt).getTime() < JUST_SET_UP_MS && !gone.includes(i.id))
    .sort((a, b) => (b.acceptedAt! < a.acceptedAt! ? -1 : 1));
  const inv = mine[0];
  if (!inv) return null;
  const emp = d.data.team.find((e) => e.id === inv.employeeId);
  const first = (emp?.name ?? inv.name ?? "Someone").split(/\s+/)[0]!;
  const people = d.data.team.filter((e) => e.active !== false);
  const setUp = people.filter((e) => !!e.userId || !!e.hasPin).length;
  const dismiss = () => { const next = [...gone, inv.id]; setGone(next); try { localStorage.setItem(SEEN_KEY, JSON.stringify(next.slice(-50))); } catch { /* private mode */ } };
  return (
    <li className="feed-item">
      <div className="reward-card" role="status" data-testid="just-set-up">
        <RewardCheck />
        <h2 className="reward-title">{inviteeSetUpLine({ first, setUp, total: people.length })}</h2>
        <Button variant="quiet" onClick={dismiss}>Hide this card</Button>
      </div>
    </li>
  );
}
